<template>
    <div>
        <div v-if="!basicInfoAdded && templatesLoaded">
            <v-btn color="addStuff" height="30" tile block @click="clickBack()">Tillbaka</v-btn>
            <template v-for="(field, index) in basicInformationTemplate.fields">
                <customfield
                    :key="index"
                    :field="field"
                    :index="index"
                    @update:value="basicInformationTemplate.fields[index].value = $event">
                </customfield>
            </template>
            <div class="button bottom">
                <v-btn
                    color="addStuff"
                    @click="submitBasicInfoForm()"
                    tile
                    block>
                Nästa
                </v-btn>
            </div>
        </div>
        <div v-else-if="basicInfoAdded && !assetTypeSelected">
            <div v-if="basicFormComplete" class="px-1 py-2 label bold"><p>OBS! {{ basicFormTitle }} är redan ifyllt</p></div>
            <div class="px-1 py-3 label bold">Välj och lägg till Anläggningstillgång/Maskinpark från listan nedan</div>
            <div v-for="assetType in availableAssetTypes" :key="assetType.id" class="assetAdd">
                <v-btn
                    @click="selectAssetType(assetType)"
                    color="addStuff"
                    tile
                    block>
                {{ assetType.name }}
                </v-btn>
            </div>
            <div>
                <div class="px-1 py-3 label bold">Befintliga Anläggningstillgångar/Maskinpark hos {{ customerProjectName }}:</div><br><br>
                <template v-if="this.$customerProjectAssets && this.$customerProjectAssets.length > 0">
                    <div class="px-0 py-0 my-2 mx-2" v-for="asset in this.$customerProjectAssets" :key="asset.id">
                        <router-link :to="{ name: 'Asset',
                                            params: {   id: asset.id,
                                                        type: asset.assetTypeName,
                                                        from: 'protocol',
                                                        basicFormComplete: basicFormComplete }}"
                        class="asset px-1 py-1">
                            {{ asset.name }} {{ asset.assetNo }}
                        </router-link>
                    </div>
                </template>
                <template v-else><div>Inga anläggningtillgångar på anläggningen</div></template>
            </div>
            <div class="button bottom">
                <v-btn
                    color="addStuff"
                    @click="$router.push({ name: 'Job', params: { fromButtonPush: true }})"
                    tile
                    block>
                Klar
                </v-btn>
            </div>
        </div>
        <div v-else-if="basicInfoAdded && assetTypeSelected && selectedAssetFormTemplate && selectedAssetFormTemplate.fields && selectedAssetFormTemplate.fields.length > 0">
            <div>
                <div class="px-1 py-3 title label bold">Fyll i protokollet</div><div class="back px-1 py-3"><v-btn color="addStuff" height="20" tile block @click="assetTypeSelected = false; selectedAssetFormTemplate = null;">Tillbaka</v-btn></div>
            </div>
            <template v-for="(field, index) in selectedAssetFormTemplate.fields">
                <customfield
                    style="display:inline-block;"
                    :key="index"
                    :field="field"
                    :index="index"
                    @update:value="selectedAssetFormTemplate.fields[index].value = $event">
                </customfield>
            </template>
            <div class="button add-stuff bottom">
                <v-btn
                    color="addStuff"
                    @click="submitAssetForm()"
                    tile
                    block>
                Lägg till
                </v-btn>
            </div>
        </div>
        <v-snackbar
                app
                v-model="snackbar"
                multi-line
                :color="this.errorMessage ? 'red accent-4' : 'green'"
                :top=true
                timeout="3000"
            >
                {{ successMessage ? successMessage : errorMessage }}
        </v-snackbar>
    </div>
</template>

<script>
import Customfield from './Customfield.vue'
export default {
    name: 'Protocol',
    props: {
        basicFormComplete: {
            type: Boolean,
            required: false
        },
        yearlyInspection: {
            type: Boolean,
            required: false
        },
        resourceName: {
            type: String,
            required: false
        }
    },
    mounted() {
        if (this.basicFormComplete) {
            this.basicInfoAdded = true;
        }
        this.fetchFormTemplates();
        this.fetchAssetTypes();
    },
    data: () => ({
        loading: false,
        formTemplates: [],
        basicInformationTemplate: null,
        basicInfoAdded: false,
        templatesLoaded: false,
        assetTypes: [],
        assetTypeSelected: false,
        selectedAssetType: null,
        selectedAssetFormTemplate: null,
        successMessage: null,
        errorMessage: null,
        snackbar: false
    }),
    beforeRouteEnter(to, from, next) {
        // When comming from Asset you must have filled out basic info form, therefore set basicInfoAdded to true to avoid loading in basic info form
        if (from.name == 'Asset') {
            next( vm => {
                vm.basicInfoAdded = true;
            })
        // when using forward button from Jobs when been on Protocol before no params is parsed - disallow forward
        } else if (from.name == 'Job' && to.params.basicFormComplete == undefined) {
            next(false);
        } else next();
    },
    beforeRouteLeave(to, from, next) {
        // if using browser back button when filling out asset form, dont go back to Job, but rather change what Protocol view show with conditional
        if (this.assetTypeSelected && to.params.fromButtonPush == undefined) {
            this.assetTypeSelected = false;
            next(false);
        } else {
            next();
        }
    },
    methods: {
        fetchFormTemplates() {
            this.loading = true;
            this.$api.get('get_form_templates/' + this.$jobId + '?access_token=' + this.$accessToken)
                .then(response => {
                    this.formTemplates = response.data;
                    if (this.formTemplates && this.formTemplates.length > 0) {
                        this.basicInformationTemplate = this.formTemplates.find(template => template.title && template.title.toLowerCase() == 'shopinformation');
                    }
                    this.templatesLoaded = true;
                    this.autoFillUserDetails();
                }, this)
                .catch(error => {
                    console.error(error)
                }, this)
                .finally(() => {
                    this.loading = false;
                }, this)
        },
        fetchAssetTypes() {
            this.loading = true;
            this.$api.get('get_asset_types/' + this.$jobId + '?access_token=' + this.$accessToken)
                .then(response => {
                        this.assetTypes = response.data;
                    }, this)
                    .catch(error => {
                        console.error(error)
                    }, this)
                    .finally(() => {
                        this.loading = false;
                    }, this)
        },
        submitAssetForm() {
            if (this.validate(this.selectedAssetFormTemplate.fields)) {
                let form = this.mapForm(this.selectedAssetFormTemplate);
                //this.saveForm(form);
                let asset = this.mapAsset();
                this.saveAsset(asset, form);
            }

        },
        mapAsset() {
            let asset = {};
            let assetType = this.selectedAssetType;
            let assetTypeCustomFields = assetType && assetType.assetTemplate && assetType.assetTemplate.customFields;
            let formCustomFields = this.selectedAssetFormTemplate && this.selectedAssetFormTemplate.fields;
            let statusField = formCustomFields && formCustomFields.find(field => field.name == 'generellstatus');
            if (!assetType || !formCustomFields || !assetTypeCustomFields) return asset;
            asset.active = true;
            asset.name = assetType.name == 'Kylutrustning' ? this.generateTitleForCooling(formCustomFields) : assetType.name;
            asset.locationDescription = this.$customerProject && this.$customerProject.locationDescription;
            asset.location = this.$customerProject && this.$customerProject.location;
            asset.assetTypeId = assetType.id;
            asset.assetTypeName = assetType.name;
            asset.customerId = this.$job && this.$job.customerId;
            asset.customerProjectId = this.$job && this.$job.customerProjectId;
            asset.customFields = this.generateCustomFields(formCustomFields, assetTypeCustomFields)
            if (statusField) {
                asset.labels = this.generateLabels(statusField);
                asset.state = this.setupAssetState(statusField);
            }
            return asset;
        },
        setupAssetState(statusField) {
            if (!statusField) return null;
            let selectedStatus = statusField && statusField.value;
            if (!selectedStatus) return null;
            if (selectedStatus.indexOf('X') == 0) return 'OUT_OF_ORDER';
            else return 'IN_USE'
        },
        generateCustomFields(formCFs, assetTypeCFs) {
            let assetTypeCustomFieldNames = assetTypeCFs.map(field => field.name);
            let customFields = [];
            formCFs.forEach(field => {
                if (assetTypeCustomFieldNames.includes(field.name)) {
                    customFields.push(field);
                }
            }); // add "inspection" to newly created assets when inspecting
            if (this.yearlyInspection) {
                let inspectionIndex = assetTypeCFs.findIndex( field => (field.value == 'Årlig besiktning' || field.value == 'Årlig service') && field.type == 'HEADER');
                if (inspectionIndex > -1) {
                    let inspectionFields = assetTypeCFs.slice(inspectionIndex)
                    if (inspectionFields && inspectionFields.length > 0) {
                        inspectionFields.forEach( field => {
                            if (field.name == 'senastebesiktad') field.value = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0,10);
                            if (field.name == 'besiktadavleverantr') field.value = this.resourceName;
                            customFields.push(field);
                        });
                    }
                }
            }
            let weight = 1;
            customFields.forEach(field => {
                field.weight = weight;
                weight ++;
            });
            return customFields;
        },
        generateLabels(statusField) {
            if (!statusField) return [];
            let status = statusField.value;
            // 1. Mycket dåligt skick, bör inte lagas när den falerar
            // 2. Fungerar men dåligt, bör bytas på sikt
            // 3. Fungerande och i bra skick.
            // 4. Mycket Bra skick
            // 5. Under garanti - i drift
            if (status) {
                if (status.indexOf('1') == 0) return ['Mycket dåligt skick'];
                else if (status.indexOf('2') == 0) return ['Bör bytas på sikt'];
                else if (status.indexOf('3') == 0) return ['Bra skick']
                else if (status.indexOf('4') == 0) return ['Mycket bra skick']
                else if (status.indexOf('5') == 0) return ['Under garanti'];
            }
            return [];
        },
        async submitBasicInfoForm() {
            if (this.validate(this.basicInformationTemplate.fields) && !this.basicInfoAdded) {
                let form = this.mapForm(this.basicInformationTemplate);
                form.title = this.generateBasicFormTitle();
                let response = await this.saveForm(form);
                if (response && response.status == 200) {
                    this.snack('Protokoll skapat!', true);
                    this.basicInfoAdded = true;
                }
            }
        },
        mapForm(template) {
            let form = {};
            if (template && template.id) {
                form.fields = template.fields;
                let datefield = form.fields && form.fields.find(field => field.name == 'datumfrbesk');
                if (datefield) {
                    datefield.value == datefield.value && new Date(datefield.value).getTime() && new Date(datefield.value).getTime().toString();
                }
                form.fromTemplateId = template.id;
                form.title = template.title == 'Kylutrustning' ? this.generateTitleForCooling(template.fields) : template.title;
                form.groupId = template.groupId;
                form.description = template.description;
                form.instructions = template.instructions;
                form.requiredFields = template.requiredFields;
                form.jobId = this.$jobId;
                form.state = 'COMPLETE';
            }
            return form;
        },
        async saveForm(form) {
            form = JSON.stringify(form);
            let response = await this.$api.post('post_form/' + this.$jobId + '?access_token=' + this.$accessToken, form)
                .catch( error => {
                    console.error('could not save form: ' + error);
                    this.snack('could not save shopinformation : ' + error)
                    }, this);
            return response;
        },
        saveAsset(asset, form) {
            let name = asset && asset.name;
            asset = JSON.stringify(asset);
            this.$api.post('post_asset/' + this.$jobId + '?access_token=' + this.$accessToken, asset)
                .then( response => {
                    if (response.data && response.data.id) this.updateAssetButtonOnForm(form, response.data.id);
                    this.saveForm(form);
                    this.assetTypeSelected = false;
                    this.selectedAssetFormTemplate = null;
                    this.selectedAssetType = null;
                    this.$root.$emit('asset-created', response.data);
                    this.snack(name + ' lagt till!', true)
                }, this)
                .catch( error => {
                    console.error('could not save asset: ' + error);
                }, this);
        },
        selectAssetType(assetType) {
            this.selectedAssetType = assetType;
            this.selectedAssetFormTemplate = JSON.parse(JSON.stringify(this.formTemplates.find(template => template.title.toLowerCase() == assetType.name.toLowerCase())));
            if (this.selectedAssetFormTemplate) {
                this.assetTypeSelected = true;
            }
        },
        clickBack() {
            this.$router.go(-1);
        },
        snack(msg, success) {
            if (success) {
                this.errorMessage = null;
                this.successMessage = msg;
            } else {
                this.successMessage = null;
                this.errorMessage = msg;
            }
            this.snackbar = true
            setTimeout(() => {
                this.successMessage = null
                this.errorMessage = null
                this.snackbar = false
            }, 3000)
        },
        validate(fields) {
            let valid = false;
            let issues = [];
            fields.forEach(field => {
                if (field.required && field.type == 'SELECT') {
                    let options = field.typeInfo && field.typeInfo.split('\n');
                    let firstOption = options && options.length > 0 ? options[0] : null;
                    if (firstOption && (field.value.toLowerCase().includes('välj') && field.value == firstOption || !field.value)) {
                        issues.push(field.label);
                    }
                }
                else if (field.required && !field.value) {
                    issues.push(field.label);
                }
            });
            if (!valid && issues.length > 0) {
                valid = false;
                let errorMessage = 'Ange: ' + issues.join(', ');
                this.snack(errorMessage);
            } else {
                valid = true;
            }
            return valid;
        },
        autoFillUserDetails() {
            let jobResources = this.$job && this.$job.resources;
            let firstResource = jobResources && jobResources[0];
            if (firstResource) {
                let nameField = this.basicInformationTemplate && this.basicInformationTemplate.fields && this.basicInformationTemplate.fields.find(field => field.name == 'servicefretag');
                if (nameField) {
                    nameField.value = firstResource.fullName || firstResource.userName;
                }
                let emailField = this.basicInformationTemplate && this.basicInformationTemplate.fields && this.basicInformationTemplate.fields.find(field => field.name == 'epostservicefirma');
                if (emailField) {
                    emailField.value = firstResource.emailAddress;
                }
                let phoneField = this.basicInformationTemplate && this.basicInformationTemplate.fields && this.basicInformationTemplate.fields.find(field => field.name == 'telefonnummerservicefirma');
                if (phoneField) {
                    phoneField.value = firstResource.phoneNo;
                }
            }
        },
        generateBasicFormTitle() {
            let managerPresentCustomField = this.basicInformationTemplate && this.basicInformationTemplate.fields && this.basicInformationTemplate.fields.find(field => field.name == 'shopmanagernrvarande');
            if (managerPresentCustomField) {
                return 'Shopinformation: CSM närvarande: ' + managerPresentCustomField.value;
            } else return this.basicInformationTemplate.title
        },
        generateTitleForCooling(customFields) {
            let title = '';
            let type = customFields && customFields.find(field => field.name == 'objekttypavkylmbel');
            if (type && type.value) title += type.value;
            let manufacture = customFields && customFields.find(field => field.name == 'objektfabrikat');
            if (manufacture && manufacture.value) title += ' - ' + manufacture.value;
            let serialNumber = customFields && customFields.find(field => field.name == 'objektserienummer2');
            if (serialNumber && serialNumber.value) title += ' - ' + serialNumber.value;
            return title;
        },
        updateAssetButtonOnForm(form, assetId) {
            let assetButton = form && form.fields && form.fields.find(field => field.name == 'assetbutton');
            let link = this.$cdnConfig.webUrl + '/#assets/' + assetId;
            if (assetButton) assetButton.value = link;
        }
    },
    computed: {
        basicFormTitle() { return this.basicInformationTemplate && this.basicInformationTemplate.title },
        customerProjectName() { return this.$customerProject ? this.$customerProject.name : (this.$job ? this.$job.customerName : 'N/A') },
        availableAssetTypes() {
            let formTitles = this.formTemplates.map( form => form.title.toLowerCase() );
            return this.assetTypes.filter( assetType => formTitles.includes(assetType.name.toLowerCase()));
         }
    },
    components: {
        Customfield
    }
}

</script>

<style lang="scss" scoped>
.button {
    width: 95%;
    display: block;
    margin-right: 50px;
    margin-top: 10px;
    margin-left: 5px;
    margin-right: 5px;
}
.assetAdd {
    margin: 5px;
}
p {
    color: green;
    margin-bottom: 0px;
}
.back {
    float: right;
}
.title {
    font-size: 18px;
}
</style>
